import { useGetMainList } from "ra-core";
import { createContext, FC, useContext, useMemo } from "react";
import { RecPatch } from "@/dataProvider/tools";
import { SecondaryClassificationResponseDto } from "@/gen/api/governance";
import { SimpleOption } from "../governance/search/AmbientFacilitiesContext";
import { pages, sorts } from "@/utils/paramsWithGetMainList";


interface ClassificationRuleAmbinetDataCotnextProps {
  classifications: (SecondaryClassificationResponseDto & RecPatch & SimpleOption)[];
}

export const ClassificationRuleAmbinetDataCotnext = createContext<ClassificationRuleAmbinetDataCotnextProps>({} as any)

export const ClassificationRuleAmbinetDataCotnextProvider : FC = ({children}) => {
  const { data: data2, ids: ids2 } = useGetMainList<SecondaryClassificationResponseDto&RecPatch>('settings/governance/data-classification', pages(), sorts(), {})

  const val = useMemo(() => ({
    classifications: (ids2 ?? [])
      .map((id) => {
        const c = data2![id as number]
        const s : SimpleOption = c as any
        s.key = c.secondaryClassificationId!
        s.text = `${c.primaryClassificationText} - ${c.name}`
        return s as any
      })
      .sort((a, b) => 
            ((a.primaryClassification || 0) - (b.primaryClassification || 0)) 
        || ((a.secondaryClassificationId || 0) - (b.secondaryClassificationId || 0))),
  }), [data2, ids2])

  return (
    <ClassificationRuleAmbinetDataCotnext.Provider value={val}>
      {children}
    </ClassificationRuleAmbinetDataCotnext.Provider>
  )
}

export const useClassificationRuleAmbinetDataCotnext = () => useContext(ClassificationRuleAmbinetDataCotnext);
